/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import e from"../../geometry/Point.js";import r from"../../geometry/SpatialReference.js";const o=new e({x:0,y:0,z:0,spatialReference:r.WebMercator}),t=1e3,m=114,a=120,i=50;export{o as defaultImageSphereCenter,t as defaultImageSphereSize,m as humanBinocularHFOV,a as maxPanoramicViewerHFOV,i as minPanoramicViewerHFOV};
